export default {
    'account-info': 'Información de la cuenta',
    save: 'Guardar',
    cancel: 'Cancelar',
    'account-name': 'Nombre de la cuenta',
    'main-account': 'Cuenta principal',
    
    'account-type': {
        title: 'Tipo de la cuenta',
        main: 'Principal',
        sub: 'Sub',
    },
    
    'final-accounts': {
        title: 'Cuenta final',
        operations: 'Explotación',
        trade: 'Mercancía',
        'gains-and-losses': 'Pérdidas y ganancias',
        budget: 'Balance general',
    },

    'custom-statement': 'Estado personalizado',
    'max-debit-amount': 'Límite de débito',
    'max-credit-amount': 'Límite de crédito',
    'debt-is-forbidden': 'Prohibido de deuda',
    'notes': 'Notas',
    'contect-info': {
        title: 'Información de contacto',
        'mobile-number': 'Móvil',
        'phone-number': 'Fijo',
        email: 'Correo electronico',
        address: 'Dirección',
    },

    'edit-account': 'Editar cuenta',
    'create-account': 'Crear cuenta',
}